"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = void 0;
class Subscription {
    constructor(defaultMetaData) {
        this.setMetaData = (metaData) => {
            this.metaData = metaData;
        };
        this.getMetaData = () => {
            if (this.metaData === undefined) {
                throw new Error("meta data not set");
            }
            return this.metaData;
        };
        this.subscribe = (fn, label) => {
            this.subscribers = [...this.subscribers, { fn, label }];
            return this.getUnsubscribeFn(fn);
        };
        this.cSubscribers = [];
        this.asyncReverseOrderSubscribe = (fn, label) => {
            this.cSubscribers.push({ fn, label });
            if (this.planned) {
                clearTimeout(this.planned);
            }
            this.planned = setTimeout(() => {
                this.subscribers = [
                    ...this.subscribers,
                    ...[...this.cSubscribers].reverse(),
                ];
                this.cSubscribers = [];
            }, 0);
            return this.getUnsubscribeFn(fn);
        };
        this.getUnsubscribeFn = (fn) => {
            return () => {
                this.subscribers = this.subscribers.filter(e => {
                    if (e.isCancelled || e.fn === fn) {
                        e.isCancelled = true;
                        return false;
                    }
                    return true;
                });
            };
        };
        this.broadcast = (...data) => {
            const arr = this.subscribers;
            const results = [];
            for (const el of arr) {
                if (el.isCancelled) {
                    continue;
                }
                results.push(el.fn(...data));
            }
            this.subscribers = this.subscribers.filter(e => !e.isCancelled);
            return results;
        };
        this.clearSubscribers = () => {
            this.subscribers = [];
        };
        if (defaultMetaData !== undefined) {
            this.metaData = defaultMetaData;
        }
        this.subscribers = [];
    }
}
exports.Subscription = Subscription;
